<template>
  <section>
    <notifications></notifications>
    <sidebar-help
      :title="$route.meta.title"
      :items="guides"
      :loader="loader"
      :toggleSidebar="visibleSideBar"
      @closeSidebar="closeSidebar"
    />
    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-4 col-md-6 col-sm-6 col-5 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-6 col-7 text-right">
          <div class="box-buttons">
            <base-button
              v-if="selectedRows.length > 0"
              type="outline-neutral"
              class="min-button btn-line-danger mr-2"
              @click="deleteManyUsers(selectedRows)"
            >
              <i class="flaticon-delete icon-no-margin"></i>
              <strong class="d-lg-block d-none">Delete</strong>
            </base-button>

            <base-button
              type="primary"
              @click="$router.push('/team/new')"
              class="min-button"
            >
              <i class="flaticon-plus"></i>New
              <strong class="d-lg-block d-none ml-1"> Member</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="main-buttons">
        <div class="row">
          <div
            class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 align-self-center mb-0"
          >
            <b-form-group class="mb-0">
              <b-input-group size="sm" class="input-search">
                <b-input-group-prepend class="pt-1 pl-1">
                  <i class="flaticon-bold-magnifier"></i>
                </b-input-group-prepend>
                <b-form-input
                  id="filter-input"
                  v-model.trim="simpleSearch"
                  v-on:input="applySimpleSearch"
                  type="search"
                  placeholder="Search Anything..."
                  class="border-none"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
          <div
            class="col-xl-8 col-lg-8 col-md-6 col-sm-6 col-12 alinmov2 align-self-center"
          >
            <div>
              <div class="box-buttons">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="li"
                  title-tag="a"
                  title-classes="btn min-button btn-outline-neutral "
                  title="Actions"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-employees"></i>
                    <strong>Position</strong>
                  </base-button>

                  <div
                    class="dropdown-item"
                    :class="'all' === userPosition ? 'active' : ''"
                    @click="addTypePosition('all')"
                  >
                    All
                  </div>

                  <div
                    v-for="(item, index) in POSITION_OPTIONS"
                    :key="index"
                    class="dropdown-item"
                    :class="item.value === userPosition ? 'active' : ''"
                    @click="addTypePosition(`${item.value}`)"
                  >
                    {{ item.label }}
                  </div>
                </base-dropdown>

                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="li"
                  title-tag="a"
                  title-classes="btn min-button btn-outline-neutral "
                  title="Actions"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-bold-lock"></i>
                    <strong>Role</strong>
                  </base-button>
                  <div
                    class="dropdown-item"
                    :class="'all' === userRole ? 'active' : ''"
                    @click="addTypeRole('all')"
                  >
                    All
                  </div>
                  <div
                    class="dropdown-item"
                    :class="'super_admin' === userRole ? 'active' : ''"
                    @click="addTypeRole('super_admin')"
                  >
                    Super Admin
                  </div>
                  <div
                    class="dropdown-item"
                    :class="'admin' === userRole ? 'active' : ''"
                    @click="addTypeRole('admin')"
                  >
                    Admin
                  </div>
                  <div
                    class="dropdown-item"
                    :class="'user' === userRole ? 'active' : ''"
                    @click="addTypeRole('user')"
                  >
                    User
                  </div>
                  <div
                    class="dropdown-item"
                    :class="'manager' === userRole ? 'active' : ''"
                    @click="addTypeRole('manager')"
                  >
                    Manager
                  </div>
                  <div
                    class="dropdown-item"
                    :class="'manager' === userRole ? 'active' : ''"
                    @click="addTypeRole('support')"
                  >
                    Support
                  </div>
                </base-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-table">
        <div class="row">
          <div
            class="col-xl-5 col-lg-7 col-md-12 col-sm-12 col-12 align-self-center order-lg-1 order-md-2 order-sm-2 order-2"
          ></div>

          <div
            class="col-xl-7 col-lg-5 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 align-self-center mb-lg-0 mb-1 text-right"
          >
            <div class="col-xl-7 col-lg-12 col-md-6 ml-auto d-inline-block">
              <b-form-group
                label="Sort"
                label-for="sort-by-select"
                label-cols-sm="2"
                label-align-sm="right"
                label-size="sm"
                v-slot="{ ariaDescribedby }"
                class="mb-2"
                size="sm"
              >
                <b-input-group>
                  <b-form-select
                    id="sort-by-select"
                    v-model="sortBy"
                    :options="SORT_TABLE_OPTIONS"
                    :aria-describedby="ariaDescribedby"
                    @change="applySortBy"
                    class="w-70"
                    size="sm"
                  >
                    <template #first>
                      <option value="">-- None --</option>
                    </template>
                  </b-form-select>

                  <b-form-select
                    v-model="sortDesc"
                    :disabled="!sortBy"
                    @change="applySortType"
                    :aria-describedby="ariaDescribedby"
                    class="w-30"
                    size="sm"
                  >
                    <option :value="'asc'">Asc</option>
                    <option :value="'desc'">Desc</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2 mb-2">
              <b-form-group v-slot="{ ariaDescribedbyview }" class="mb-0">
                <b-form-radio-group
                  id="btn-radios-view"
                  v-model="view"
                  :aria-describedby="ariaDescribedbyview"
                  name="radios-btn-default"
                  buttons
                  @change="viewCard"
                  class="mb-0"
                  button-variant="outline-neutral pc-3"
                >
                  <b-form-radio value="table"
                    ><i class="flaticon-two" title="View Table"></i
                  ></b-form-radio>
                  <b-form-radio value="card"
                    ><i class="flaticon-menu" title="View Card"></i
                  ></b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>

            <div v-if="canUserExport" class="d-inline-block mr-2 mb-2">
              <el-tooltip content="Export" placement="bottom">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="div"
                  title-tag="a"
                  title-classes="btn btn-outline-neutral btn-icon-only m-0 dropnocaret"
                  title="Export"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-downloading-files mr-0 mt-2"></i>
                  </base-button>

                  <div
                    class="dropdown-item"
                    @click="download(selectedRows)"
                    v-if="selectedRows.length > 0"
                  >
                    Selected Records
                  </div>
                  <div class="dropdown-item" @click="download([])">
                    All Records
                  </div>
                </base-dropdown>
              </el-tooltip>
            </div>

            <div class="d-inline-block  mb-2">
              <el-tooltip content="Help" placement="bottom">
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="openSideBar"
                >
                  <i class="flaticon-question-1 f-16 mr-0"></i>
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </div>

        <div>
          <pagination-block
            :pageCount="usersResponse.pages"
            :total="usersResponse.count"
            v-model="currentPage"
            :limit="limit"
            @changeLimit="changeLimit"
            @changePage="changePage"
            @nextPage="nextPaginations"
            @prevPage="previousPaginations"
            position="bottom"
          ></pagination-block>

          <b-table
            hover
            :items="users"
            :fields="TEAMS_FIELDS"
            sort-by.sync="created_at"
            sort-asc.sync="true"
            selectable
            @row-selected="onRowSelected"
            select-mode="multi"
            ref="selectableTable"
            sort-icon-left
            responsive
            show-empty
            empty-filtered-text="There are no records matching your request"
            empty-text="There are no records to show"
            :stacked="cardview"
          >
            <template #head()="{ label, field: { key } }">
              <span v-if="key === 'selected'">
                <span
                  @click="clearSelected"
                  v-if="selectedRows.length === users.length"
                  class="check-table selected"
                ></span>

                <span @click="selectAllRows" v-else class="check-table"></span>
              </span>
              <span v-else>{{ label }}</span>
            </template>
            <template #cell(selected)="{ rowSelected }">
              <template v-if="rowSelected">
                <span aria-hidden="true" class="check-table selected"></span>
                <span class="sr-only">Selected</span>
              </template>
              <template v-else>
                <span aria-hidden="true" class="check-table"></span>
                <span class="sr-only">Not selected</span>
              </template>
            </template>

            <template #cell(username)="data">
              <router-link
                :to="`/team/${data.item._id}`"
                class="link-img-profile"
              >
                <div
                  v-if="data.item.profile.image"
                  class="img-user-list"
                  v-bind:style="{
                    backgroundImage: `url('${data.item.profile.image}')`
                  }"
                ></div>

                <div
                  v-else
                  class="img-user-list"
                  v-bind:style="{
                    backgroundImage: 'url(' + imageProfile + ')'
                  }"
                ></div>

                <div class="content">
                  <span class="username hide-data">
                    {{ data.item.personal_info.first_name }}
                    {{ data.item.personal_info.last_name }}</span
                  >
                </div>
              </router-link>
            </template>

            <template #cell(position)="data">
              <span>{{ formatPosition(data.item.agreement.position) }}</span>
            </template>

            <template #cell(email)="data">
              <a
                class="hide-data"
                :href="
                  `https://mail.google.com/mail/?view=cm&fs=1&to=${data.item.account.email}`
                "
                target="_blank"
                >{{ data.item.account.email }}</a
              >
            </template>

            <template #cell(role)="data">
              <span class="text-capitalize">
                {{ formatRole(data.item.relationship.type) }}
              </span>
            </template>

            <template #cell(status)="data">
              <div
                class="badge-status"
                :class="
                  data.item.profile.status ? 'badge-success' : 'badge-danger'
                "
              >
                <span v-if="data.item.profile.status">Active</span>
                <span v-else>Inactive</span>
              </div>
            </template>

            <template #cell(actions)="data">
              <el-tooltip content="Edit" placement="bottom">
                <router-link
                  class="icon-action text-blue"
                  :to="`/team/${data.item._id}`"
                >
                  <i class="flaticon-pencil text-primary"></i>
                </router-link>
              </el-tooltip>

              <el-tooltip
                :content="data.item.profile.status ? 'Deactivate' : 'Activate'"
                placement="bottom"
              >
                <span
                  class="icon-action text-info ml-2"
                  @click.stop="
                    changeStatus(data.item._id, !data.item.profile.status)
                  "
                >
                  <i class="flaticon-right-4"></i>
                </span>
              </el-tooltip>

              <base-dropdown
                menu-on-right
                class="nav-item"
                tag="li"
                title-tag="a"
                title-classes="dropnocaret"
                title="Actions"
              >
                <span slot="title">
                  <i class="flaticon-envelope text-warning ml-2"></i
                ></span>
                <div
                  class="dropdown-item"
                  @click.stop="resendWelcomeEmail(data.item._id)"
                >
                  <span class="icon-action">
                    <i class="flaticon-send text-warning"> </i>

                    Send Welcome Email
                  </span>
                </div>
                <div
                  class="dropdown-item"
                  @click.stop="sendEmailSignature(data.item._id)"
                >
                  <span class="icon-action">
                    <i class="flaticon-send text-warning"></i> Send Email
                    Signature
                  </span>
                </div>
              </base-dropdown>

              <el-tooltip content="Delete" placement="bottom">
                <span
                  class="icon-action text-danger ml-2"
                  @click.stop="deleteUser(data.item._id)"
                >
                  <i class="flaticon-delete"></i>
                </span>
              </el-tooltip>
            </template>
          </b-table>
          <pagination-block
            :pageCount="usersResponse.pages"
            :total="usersResponse.count"
            :limit="limit"
            @changeLimit="changeLimit"
            v-model="currentPage"
            @changePage="changePage"
            @nextPage="nextPaginations"
            @prevPage="previousPaginations"
            position="bottom"
          ></pagination-block>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import { UsersAPI, ExportAPI, DocumentsAPI } from "../../../core/api";
import Swal from "sweetalert2";
import moment from "moment";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
import { goBack, isUserAuthorized } from "../../../helpers/commons.helpers";
import { formatPosition, formatRole } from "../utils/formatUserType";
import {
  POSITION_OPTIONS,
  SORT_TABLE_OPTIONS,
  TEAMS_FIELDS
} from "../constants/team.constants";

export default {
  name: "Teams",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data() {
    return {
      currentPage: 1,
      selectedRows: [],
      limit: 0,
      query: "",
      cardview: false,
      simpleSearch: "",
      sortBy: "",
      sortDesc: "asc",
      TEAMS_FIELDS,
      SORT_TABLE_OPTIONS,
      POSITION_OPTIONS,
      timeoutId: null,
      userRole: "all",
      userPosition: "all",
      imageProfile: require("rhomtrip_assets/src/img/users/user-placeholder.png"),
      guides: [],
      loader: false,
      visibleSideBar: false,
      view: "table"
    };
  },
  async mounted() {
    this.setItemsBread([
      {
        text: "Dashboard",
        to: "/dashboard"
      },

      {
        text: "Team",
        active: true
      }
    ]);
  },
  async created() {
    this.getLimit();
    this.limit = this.paginationLimit;
    this.currentPage = this.userSearchCriteria.currentPage;
    this.query = this.userSearchCriteria.query;
    this.initializeFilterData(this.query);
    await this.get(true, this.limit, this.currentPage, this.query);
  },
  methods: {
    formatPosition,
    formatRole,
    async get(loader, limit, page, query) {
      await this.getUsers({
        loader: loader,
        limit: limit,
        page: page,
        query: query
      });
      this.setUserSearchCriteria({
        currentPage: page,
        limit: limit,
        query: query,
        status: true
      });
    },
    async changeLimit(limit) {
      if (this.limit !== limit) {
        this.limit = limit;
        this.currentPage = 1;
        await this.get(true, this.limit, this.currentPage, this.query);
      }
    },
    async previousPaginations(page) {
      await this.get(true, this.limit, page, this.query);
    },
    async nextPaginations(page) {
      await this.get(true, this.limit, page, this.query);
    },
    async changePage(page) {
      await this.get(true, this.limit, page, this.query);
    },
    addElementInQuery(query, key, value) {
      let searchParams = new URLSearchParams(query);
      if (searchParams.has(key)) {
        searchParams.set(key, value ? value : value.trim());
      } else {
        searchParams.append(key, value ? value : value.trim());
      }
      return searchParams.toString();
    },
    deleteItemInQuery(query, keys = []) {
      let searchParams = new URLSearchParams(query);
      keys.forEach(key => {
        if (searchParams.has(key)) {
          searchParams.delete(key);
        }
      });
      return searchParams.toString();
    },
    async applySimpleSearch(value) {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(async () => {
        if (value) {
          this.query = this.addElementInQuery(
            this.query,
            "search",
            value.trim()
          );
          await this.get(true, this.limit, 1, this.query);
        } else {
          this.query = this.deleteItemInQuery(this.query, ["search"]);
          await this.get(true, this.limit, 1, this.query);
        }
      }, 500);
    },
    async addTypePosition(type) {
      this.userPosition = type;
      if (type === "all") {
        this.query = this.deleteItemInQuery(this.query, ["position"]);
        await this.get(true, this.limit, 1, this.query);
      } else {
        this.query = this.addElementInQuery(this.query, "position", type);
        await this.get(true, this.limit, 1, this.query);
      }
    },
    async addTypeRole(type) {
      this.userRole = type;
      if (type === "all") {
        this.query = this.deleteItemInQuery(this.query, ["role"]);
        await this.get(true, this.limit, 1, this.query);
      } else {
        this.query = this.addElementInQuery(this.query, "role", type);
        await this.get(true, this.limit, 1, this.query);
      }
    },
    async applySortBy(value) {
      this.query = this.addElementInQuery(this.query, "sortBy", value);
      this.query = this.addElementInQuery(
        this.query,
        "sortType",
        this.sortDesc
      );
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    async applySortType(value) {
      this.query = this.addElementInQuery(this.query, "sortType", value);
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    async deleteUser(userId) {
      let { value } = await Swal.fire({
        title: "Delete User",
        text: "Are you sure do you want to delete this User?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteUserById(userId);
      }
    },
    async deleteUserById(userId) {
      try {
        this.setLoad(true);
        let { data } = await UsersAPI.deleteUser(userId, this.sesion.token);
        this.setLoad(false);
        if (data.data.deleted) {
          await this.get(true, this.limit, this.currentPage, this.query);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The User has been Deleted",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation could not be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async deleteManyUsers(users = []) {
      let { value } = await Swal.fire({
        title: "Delete Users",
        text: "Are you sure do you want to delete the selected Users?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        this.deleteManyUsersById(users.map(element => element._id));
      }
    },
    async deleteManyUsersById(users = []) {
      try {
        this.setLoad(true);
        let { data } = await UsersAPI.deleteUsersMany(
          { users: users },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.data.deleted) {
          await this.get(true, this.limit, this.currentPage, this.query);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Users has been Deleted",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation could not be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async changeStatus(userId, status) {
      let { value } = await Swal.fire({
        title: "Change Status",
        text: `Are you sure do you want change status the selected User?`,
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.changeStatusById(userId, status);
      }
    },
    async changeStatusById(userId, status) {
      try {
        this.setLoad(true);
        let { data } = await UsersAPI.updateSameAttribute(
          userId,
          { "profile.status": status },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          await this.get(true, this.limit, this.currentPage, this.query);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Users has been Updated",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation could not be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async download(users = []) {
      this.setLoad(true);
      let { data } = await ExportAPI.exportCSVUsers(
        { operators: users },
        this.sesion.token
      );
      this.setLoad(false);
      try {
        if (data.code === 200) {
          const url = window.URL.createObjectURL(new Blob([data.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `users-${moment().format("DD-MM-YYYY")}.csv`
          );
          document.body.appendChild(link);
          link.click();
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data was not download. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The data was not download. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    getOwner(sesion) {
      return sesion.role === sesion.account_type.type
        ? sesion.id
        : sesion.account_type.owner;
    },
    viewCard() {
      if (this.view === "table") {
        this.cardview = false;
      } else {
        this.cardview = true;
      }
    },
    async resendWelcomeEmail(userId) {
      let { value } = await Swal.fire({
        title: "Sent Email",
        text: `Are you sure do you want to resend welcome email?`,
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.resendWelcomeEmailByUserId(userId, true);
      }
    },
    async resendWelcomeEmailByUserId(userId, status) {
      try {
        this.setLoad(true);
        let { data } = await UsersAPI.resendWelcomeEmail(
          userId,
          status,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "A welcome email has been sent to the user.",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation could not be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    initializeFilterData(query) {
      let searchCriteria = new URLSearchParams(query);
      this.simpleSearch = searchCriteria.has("search")
        ? searchCriteria.get("search")
        : "";
      this.userRole = searchCriteria.has("role")
        ? searchCriteria.get("role")
        : "all";
      this.userPosition = searchCriteria.has("position")
        ? searchCriteria.get("position")
        : "all";
    },
    isInMemberModule(modules = []) {
      if (!(modules.indexOf("users") > -1)) {
        this.setUserSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    closeSidebar(status) {
      this.visibleSideBar = status;
    },
    async openSideBar() {
      this.visibleSideBar = true;
      this.loader = true;
      this.guides = await this.getSupportDocuments("INTERNAL", "TEAM");
      this.loader = false;
    },
    async getSupportDocuments(app, module) {
      try {
        let { data } = await DocumentsAPI.getSupportDocuments(
          app,
          module,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    async sendEmailSignature(userId) {
      let { value } = await Swal.fire({
        title: "Sent Email",
        text: `Are you sure do you want to send email signature?`,
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.sendEmailSignatureById(userId, true);
      }
    },
    async sendEmailSignatureById(userId) {
      try {
        this.setLoad(true);
        let { data } = await UsersAPI.sendEmailSignatureById(
          userId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The email signature has been sent to the user.",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation could not be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    ...mapActions(["getUsers", "getSearchUsers", "getLimit"]),
    ...mapMutations(["setLoad", "setItemsBread", "setUserSearchCriteria"])
  },
  computed: {
    users: function() {
      return this.usersResponse.docs ? this.usersResponse.docs : [];
    },
    canUserExport() {
      return isUserAuthorized("TEAMS", this.userRole, "EXPORT");
    },
    ...mapGetters([
      "usersResponse",
      "sesion",
      "paginationLimit",
      "userSearchCriteria"
    ])
  },
  destroyed() {
    clearTimeout(this.timeoutId);
  },
  beforeRouteLeave(to, from, next) {
    this.isInMemberModule(to.meta.modules);
    next();
  }
};
</script>
<style lang="scss"></style>
